import { combineReducers } from "redux";

const rootReducer = (reducers) =>
  combineReducers({
    // routing: routerReducer,
    constants: (state = {}) => state,
    ...reducers,
  });

export default rootReducer;
